import type { ContractChangeStatusEnum } from 'gql/graphql';

import type { MutableRefObject } from 'react';
import { useImperativeHandle } from 'react';

import { AgreementFormTopPanel } from '../AgreementFormTopPanel';
import { AgreementPriceListTable } from '../AgreementPriceListTable';
import { AgreementsAddMtr } from '../AgreementsAddMtr';
import { useGetAgreementMtrItems } from '../hooks/useGetAgreementMtrItems';
import { useRemoveAgreementsMtr } from '../hooks/useRemoveAgreementsMtr';

const noDataComp = () => 'Для отображения данных добавьте МТР';

export const AgreementPriceListMtr = ({
    agreementId,
    refreshData,
    disabledByStatus,
    isDisabledByProjectStatus,
    isDisabledByContractStatus,
    infoText = undefined,
    needUpdateCurrentPriceList,
    contractChangeStatus,
    needUpdatePriceListHandler,
    agreementTableApiRef,
    hasItemRow,
}: {
    agreementId: number;
    refreshData: () => void;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
    infoText?: string;
    needUpdateCurrentPriceList?: boolean;
    contractChangeStatus?: ContractChangeStatusEnum;
    needUpdatePriceListHandler?: (nextState: boolean) => void;
    agreementTableApiRef: MutableRefObject<{ refreshCurrentTable: (skipCheckedReset?: boolean) => void } | undefined>;
    hasItemRow: boolean;
}) => {
    const {
        datasource,
        columns,
        columnsForTableSettings,
        requestStatus,
        isColumnVisible,
        handleTableSettingsConfirm,
        rowCount,
        totalCount,
        checkedIdsArr,
        handleClearChecked,
        refreshAgreementMtr,
        refreshFilters,
        tableRef,
    } = useGetAgreementMtrItems({
        contractChangeId: agreementId,
        refreshData,
        disabledByStatus,
        isDisabledByProjectStatus,
        needUpdateCurrentPriceList,
        contractChangeStatus,
        needUpdatePriceListHandler,
    });

    useImperativeHandle(agreementTableApiRef, () => ({ refreshCurrentTable: refreshAgreementMtr }), [
        refreshAgreementMtr,
    ]);

    const {
        removeMtrsContractChangeData,
        removeMtrsContractChangeStatus,
        removeMtrsContractChangeError,
        removeMtrsContractChangeSetData,
        handleRemoveMtrsContractChange,
    } = useRemoveAgreementsMtr(agreementId, checkedIdsArr, refreshAgreementMtr, refreshFilters);

    return (
        <>
            <AgreementFormTopPanel infoText={infoText}>
                <AgreementsAddMtr
                    disabledByStatus={disabledByStatus}
                    refreshAgreementMtr={refreshAgreementMtr}
                    isDisabledByProjectStatus={isDisabledByProjectStatus}
                    isDisabledByContractStatus={isDisabledByContractStatus}
                    refreshFilters={refreshFilters}
                />
            </AgreementFormTopPanel>
            <AgreementPriceListTable
                refreshCurrentTableRef={tableRef}
                rowCount={rowCount}
                totalCount={totalCount}
                columnsForTableSettings={columnsForTableSettings}
                handleTableSettingsConfirm={handleTableSettingsConfirm}
                isColumnVisible={isColumnVisible}
                datasource={datasource}
                columns={columns}
                requestStatus={requestStatus}
                checkedIdsArr={checkedIdsArr}
                handleClearChecked={handleClearChecked}
                removeRowsData={removeMtrsContractChangeData}
                removeRowsStatus={removeMtrsContractChangeStatus}
                removeRowsError={removeMtrsContractChangeError}
                removeRowsSetData={removeMtrsContractChangeSetData}
                handleRemoveRows={handleRemoveMtrsContractChange}
                tableContext={{ tableUniqueId: 'agreementMtrItems' }}
                emptyDataComponent={noDataComp}
                hasItemRow={hasItemRow}
            />
        </>
    );
};
AgreementPriceListMtr.displayName = 'AgreementPriceListMtr';
